const PAGES_TO_READ = 3;

async function loadPdfReader() {
  const [pdfReader, workerModule] = await Promise.all([
    import("pdfjs-dist"),
    import("pdfjs-dist/build/pdf.worker.min.mjs?url"),
  ]);
  pdfReader.GlobalWorkerOptions.workerSrc = workerModule.default;
  return pdfReader;
}

let pdfReaderPromise: ReturnType<typeof loadPdfReader> | null = null;

export async function firstPagesText(file: File): Promise<string> {
  pdfReaderPromise ??= loadPdfReader();
  const pdfReader = await pdfReaderPromise;
  const pdfDocument = await pdfReader.getDocument({ data: new Uint8Array(await file.arrayBuffer()) }).promise;
  try {
    const pageTexts: string[] = [];
    for (let pageNumber = 1; pageNumber <= Math.min(PAGES_TO_READ, pdfDocument.numPages); pageNumber++) {
      const page = await pdfDocument.getPage(pageNumber);
      const textContent = await page.getTextContent();
      pageTexts.push(textContent.items.map((item) => ("str" in item ? item.str : "")).join(" "));
    }
    return pageTexts.join(" ");
  } finally {
    await pdfDocument.destroy();
  }
}
